<template>
  <div v-if="contents && selectedContentType" style="padding: 40px;">
    <table 
      width="100%" 
      border="0" 
      cellspacing="0"
      cellpadding="0"
    >
      <!--tr style="height: 60px;">
        <td 
          colspan="4"
        >
          <span class="title"><b>{{ getTranslation({ es: 'PROGRAMA DE ACTIVIDADES', en: 'PROGRAMME OF ACTIVITIES', de: 'TÄTIGKEITSPROGRAMM' }, locale) }} </b></span><span class="hotel">{{hotel}}</span>
        </td>
        <td 
          class="right"
          colspan="3"
        >
          <span class="date">{{date}}</span><span class="hour" :key="time"><b>{{time}}</b></span>
        </td>
      </tr-->
      <tr style="vertical-align: bottom;height: 110px;">
        <td style="text-aling: center;width:285px">
          <center>
          <v-img
            v-if="iconColored"
            :key="iconColored"
            :src="iconColored"
            width="150"
            style="height:auto;"
          />
          </center>
        </td>
        <td 
          colspan="6"
          style="text-align: right; vertical-align:bottom;padding-bottom: 15px;"
        >
          <v-btn
            v-for="content of contents"
            :key="content.ID"
            :variant="content.ID !== selectedContentType.ID ? 'text' : 'flat'"
            :color="content.ID === selectedContentType.ID ? selectedContentType.Color : content.Color"
            @click="() => handleChangeContentType(content)"
            elevation="0"
            :xLarge="content.ID === selectedContentType.ID"
            style="border-radius: 10px 10px !impotant;margin-right: 5px;margin-bottom:0;padding:10px;"
          >
            <span :style="{ color: content.ID !== selectedContentType.ID ? 'white' : 'white' }">{{getTranslation(content.Title, locale)}}</span>
          </v-btn>
        </td>
      </tr>
      <!--tr>
        <td 
          colspan="7"
        >
          <v-btn
            v-for="content of contents"
            :key="content.ID"
            :variant="content.ID !== selectedContentType.ID ? 'text' : 'flat'"
            :color="content.ID === selectedContentType.ID ? selectedContentType.Color : null"
            @click="() => handleChangeContentType(content)"
            elevation="0"
            tile
            style="border-radius: 10px 10px 0 0 !impotant;margin-right: 0px;padding:0 30px;"
          >
            <span :style="{ color: content.ID !== selectedContentType.ID ? 'black' : 'white' }">{{getTranslation(content.Title, locale)}}</span>
          </v-btn>
        </td>
      </tr-->
      <tr>
        <td 
          colspan="7"
        >
          <week-menu
             :day="daysToAdd"
             :primaryColor="selectedContentType.Color"
             :secondaryColor="selectedContentType.Color"
             :locale="locale"
             :onChange="handleChangeDay"
          />
        </td>
      </tr>
      <tr>
        <td 
          colspan="7"
          style="padding-bottom: 15px;"
        >
          <v-select
            v-model="categoryFilter"
            :items="prepareCategories(selectedContentType.Categories, locale)"
            outlined
            block
            item-text="Name"
            itemValue="ID"
            hideDetails
          />
        </td>
      </tr>
      <tr style="height: 40px;border-radius:5px;">
        <td 
          class="day"
          colspan="7"
        >
          <div
            style="overflow-y: scroll; height:622px;"
          >
          <v-layout wrap v-if="!loading">
            <v-flex xs12 v-if="events && events.length === 0" style="text-align: center;padding: 100px 200px;color: #CCCCCC;">
              <h1>{{ $t('booking.noEvents', locale) }}</h1>
            </v-flex>
            <v-flex 
              xs6
              v-for="(event, index) of events"
              :key="event.id"
              :style="{ padding: index % 2 === 0 ? '5px 5px 5px 0' : '5px 0 5px 5px' }"
            >
              <event
                v-if="event"
                :key="`${event.id}_${index}`"
                :event="event"
                :locale="locale"
                contentColor="black"
                titleColor="black"
                primaryColor="black"
                :secondaryColor="selectedContentType.Color"
                timeColor="black"
                :noAddToCalendar="true"
              />
            </v-flex>
          </v-layout>
          </div>
        </td>
      </tr>
    </table>
  </div>
</template>
<script>
import axios from 'axios'
import Event from './event/Index'
import WeekMenu from './WeekMenu'
export default {
  components: {
    Event,
    WeekMenu,
  },
  props: {
    dviewDviewcontentID: {
      type: String,
      required: true,
    },
    locale: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    loading: false,
    hotel: '',
    contents: null,
    date: null,
    time: null,
    selectedContentType: null,
    categoryFilter: null,
    daysToAdd: 0,
    events: [],
    iconColored: null,
  }),
  watch: {
    dviewDviewcontentID () {
      this.handleGetData()
    },
    'selectedContentType.ID' () {
      this.iconColored = this.selectedContentType && this.selectedContentType.ActivityBarceloConfig ? JSON.parse(this.selectedContentType.ActivityBarceloConfig).IconColored : null
      this.handleGetEvents()
    },
    categoryFilter () {
      this.handleGetEvents()
    },
    daysToAdd () {
      this.handleGetEvents()
    },
  },
  mounted () {
    this.prepareDateTime()
    this.handleGetData()
  },
  methods: {
    checkBorder (contents, selectedID, item) {
      if (contents[0].ID === selectedID && item === 0) return '0 0 0 5px'
      return item === 0 ? '5px 0 0 5px' : item === 6 ? '0 5px 5px 0' : null
    },
    getTranslation (v, locale) {
      if (!v) return ''
      if (v[locale]) return v[locale]
      if (v['es']) return v['es']
      return v[0]
    },
    pad: function (value, nItem = 2) {
      let aux = ''
      for (let i = 0; i < nItem; i++) aux = aux.concat('0')
      let result = aux.concat(value)
      result = result.substring(result.length - nItem, result.length)
      return result
    },
    convertTime (v) {
      if (!v) return '00:00'

      const h = v / 60 | 0
      const m = v - (h * 60)
      return `${this.pad(h)}:${this.pad(m)}`
    },
    prepareDateTime () {
      const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
      this.date = new Date().toLocaleDateString(this.locale, options).toUpperCase()
      this.time = new Date().toLocaleTimeString(this.locale, { hour: 'numeric', hour12: false, minute: 'numeric' })
    },
    prepareCategories (v, locale) {
      const result = [{ ID: null, Name: this.getTranslation({ es: 'TODOS', en: 'ALL', }, locale) }]

      result.push(...v.map(item => {
        return {
          ID: item.ID,
          Name: this.getTranslation(item.Name, locale)
        }
      }))
      return result
    },
    handleGetData () {
      if (!this.dviewDviewcontentID) return
      const url = `https://cm-dviewcontent-api.dviewcontent.com/v1/public/workspaces/${this.dviewDviewcontentID}/activity-barcelo`
      axios.get(url)
        .then(response => {
          this.contents = response.data.map(item => {
            const aux = JSON.parse(item.ActivityBarceloConfig)
            item.Title = aux.Title
            item.Color = aux.Color
            item.Categories = aux.Categories
            return item
          })
          this.selectedContentType = this.contents[0]
          //this.handleGetEvents()
        })
    },
    handleChangeContentType (v) {
      this.categoryFilter = null
      this.selectedContentType = v
    },
    handleChangeDay (v) {
      this.daysToAdd = v
    },
    handleGetEvents () {
      this.loading = true
      this.events = []
      let date = new Date()
      date.setDate(date.getDate() + this.daysToAdd)
      date = date.toISOString().split('T')[0]
      const url = `https://cm-dviewcontent-api.dviewcontent.com/v1/public/activity-barcelo/${this.selectedContentType.ID}/events/${date}`
      axios.get(url)
        .then(response => {
          response.data = response.data.map(item => {
              const title = this.getTranslation(JSON.parse(item.Title), this.locale)
              const category = this.selectedContentType && this.selectedContentType.Categories 
                ? this.selectedContentType.Categories.filter(x => x.ID === item.CategoryID).shift() 
                : null
              
              return {
                id: item.ID,//title.es.toUpperCase(),
                categoryID: item.CategoryID,
                title: item.Title ? JSON.parse(item.Title) :  null,
                description: item.Description ? JSON.parse(item.Description) : null,
                time: `${this.convertTime(item.Time)} - ${this.convertTime(item.TimeEnd)}`,
                subtitle: null,
                image: item.Image ? item.Image : category ? category.Image : null,
                reservationRequired: item.ReservationRequired,
                place: item.Place ? JSON.parse(item.Place) : null,
                categoryID: item.CategoryID,
                tag: category ? category.Name : null,
                color: category ? category.Color : null,
                timeColor: this.selectedContentType.Color,
                reservable: item.Reservable,
                PVPHosted: item.PVPHosted,
                PVPNoHosted: item.PVPNoHosted,
            }
          })
          this.events = response.data.filter(x => !this.categoryFilter || x.categoryID === this.categoryFilter)
          this.loading = false
        })
        .catch(error => {
          console.log(error)
          this.loading = false
        })
    },
  },
}
</script>

